<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { RouterLink, RouterView, useRouter } from 'vue-router'
import { useRuntimeStore } from '../stores/runtime'

const store = useRuntimeStore()
const router = useRouter()
const menuOpen = ref(false)
const sdkAdmin = ref(false)
const serviceUrl = import.meta.env.VITE_SERVICE_URL || '#'

const canAdmin = computed(() => store.isAdmin || sdkAdmin.value)

const fullName = computed(() => {
  const user = store.currentUser
  const name = [user?.name, user?.last_name].filter(Boolean).join(' ').trim()
  return name || (user?.id ? `Пользователь ${user.id}` : 'Пользователь')
})

onMounted(async () => {
  if (!store.ready) {
    let restored = false
    try { restored = await store.restore() }
    catch (error) { await router.replace('/error?message=' + encodeURIComponent((error as Error).message)); return }
    if (!restored) {
      await router.replace('/error?reason=session')
      return
    }
  }
  if (window.BX24?.init) {
    window.BX24.init(() => {
      sdkAdmin.value = Boolean(window.BX24?.isAdmin?.())
      window.BX24?.fitWindow?.()
    })
  }
})
</script>

<template>
  <div class="app-shell">
    <header class="topbar">
      <RouterLink class="brand" to="/">S-A-S Forms</RouterLink>
      <div class="topbar__spacer" />
      <div class="user-menu">
        <button class="user-menu__button" type="button" @click="menuOpen = !menuOpen">
          <span class="avatar">{{ fullName.slice(0, 1).toUpperCase() }}</span>
          <span>{{ fullName }}</span>
          <span class="chevron">⌄</span>
        </button>
        <div v-if="menuOpen" class="user-menu__dropdown">
          <RouterLink to="/profile" @click="menuOpen = false">Личный кабинет</RouterLink>
          <RouterLink v-if="canAdmin" to="/settings" @click="menuOpen = false">Подключение</RouterLink>
          <a v-if="canAdmin" :href="serviceUrl" target="_blank" rel="noopener">Открыть S-A-S Forms</a>
        </div>
      </div>
    </header>

    <main class="content">
      <div v-if="store.blocked" class="notice error" role="alert">{{ store.error }} <a :href="serviceUrl" target="_blank" rel="noopener">Открыть кабинет S-A-S Forms</a></div>
      <RouterView />
    </main>
  </div>
</template>
